export enum JobState {
  queued = 'queued',
  inProgress = 'in_progress',
  completed = 'completed',
  failed = 'failed',
}

export enum DocumentProcessingJobType {
  InspectionSummary = 'inspection_summary',
  RequestForQuotation = 'rfq',
  IssueKnowledgeBase = 'issue_knowledge_base',
  DocumentUploadBatch = 'document_upload_batch',
}

export enum AIAnalysisState {
  textExtraction = 'text_extraction',
  aiPrompting = 'ai_prompting',
  savingToDatabase = 'saving_to_database',
  alertingSystems = 'alerting_systems',
  completed = 'completed',
  failed = 'failed',
}

export interface DocumentProcessingJob {
  id: string;
  createdAt: number;
  updatedAt: number;
  userId: string;
  state: JobState;
  jobType?: DocumentProcessingJobType;
  aiAnalysisState?: AIAnalysisState;
  errorCode?: string;
  errorReason?: string;
  documentIds: string[];
  propertyId?: string;
  resultJsonUrl?: string;
  messages?: { code: string; level: string; text: string }[];
  expectedDocumentCount?: number;
  completedDocumentCount?: number;
  succeededDocumentCount?: number;
  failedDocumentCount?: number;
  needsAttentionDocumentCount?: number;
  uploadFailedDocumentCount?: number;
}
